import React from 'react';

const roles = ['Super user', 'Administrator', 'User', 'Operater'];

const tables = [
    'artikal',
    'cenovnik',
    'dokumenti',
    'faktura',
    'jm',
    'kurs',
    'm',
    'marka_trosila',
    'mm',
    'mm_import',
    'mrs',
    'namena_potrosnje',
    'ni',
    'p',
    'param',
    'pkgp',
    'pp',
    'pugi',
    'rvp',
    'si',
    'status',
    'stavka_fakture',
    'tip_trosila',
    'users',
    'valuta',
    'vno',
    'vparam',
    'zm'
];

// Dummy permissions: Super user has all, Administrator has all except failed_jobs/migrations/mm_import, User has read-only, Operater has limited
const permissions = {
    'Super user': tables.reduce((acc, t) => ({ ...acc, [t]: 'Full' }), {}),
    Administrator: tables.reduce(
        (acc, t) => ({
            ...acc,
            [t]: ['mm_import', 'param', 'faktura', 'stavka_fakture', 'kurs', 'status'].includes(t) ? 'No access' : 'Full'
        }),
        {}
    ),
    User: tables.reduce((acc, t) => ({ ...acc, [t]: ['mm_import', 'param', 'faktura', 'stavka_fakture', 'kurs', 'artikal', 'cenovnik', 'jm', 'status'].includes(t) ? 'No access' : 'Full' }), {}),
    Operater: tables.reduce(
        (acc, t) => ({
            ...acc,
            [t]: ['faktura', 'stavka_fakture', 'users'].includes(t) ? 'Full' : 'No access'
        }),
        {}
    )
};

export default function Permission() {
    return (
        <div style={{ padding: 24 }}>
            <h2>Prava pristupa tabelama</h2>
            <table border="1" cellPadding={6} style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                    <tr>
                        <th>Tabela</th>
                        {roles.map((role) => (
                            <th key={role}>{role}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {tables.map((table) => (
                        <tr key={table}>
                            <td>{table}</td>
                            {roles.map((role) => (
                                <td key={role + table}>{permissions[role][table]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
